"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerService = void 0;
class ContainerService {
    constructor() {
        this.container = {};
    }
    get(key) {
        return this.container[key];
    }
    registerInstance(key, instance) {
        this.container[key] = instance;
    }
}
exports.ContainerService = ContainerService;
//# sourceMappingURL=container.service.js.map